import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/gyranians-box.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-01b390e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container report-ready-page" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "gyranian-image",
    src: _imports_0,
    alt: "Gyranians"
  })
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  style: {"margin-bottom":"25px"},
  "data-test": "report-ready-text"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]

import { computed } from "vue";
import useAxios from "../composables/api";
import { QuestionnaireApiModel } from "../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'report-ready-page',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const { data } = useAxios<QuestionnaireApiModel>(`/api/review/${props.id}`);

const reportButtonText = computed(() => {
  if (data.value?.isSelfReview) {
    return " Solo Report ";
  }
  if (data.value?.subjectIsDummy || data.value?.visibleOnlyToReviewer) {
    return " See results ";
  }
  return `Your View on ${data.value?.subjectName}`;
});

const headerText = computed(() => {
  if (data.value?.isSelfReview) return "Well done on completing a new Gyre self-review";
  return "Thank you!";
});

const continueButtonText = computed(() => {
  if (data.value?.reviewerHasCompletedFoundationsPathway) return "Continue your journey";
  return "Start Foundations Pathway";
});

const continueYourJourneyText = computed(() => {
  if (!data.value?.reviewerHasCompletedFoundationsPathway) {
    return "Continue your journey with Gyre. Click the button below and complete the Foundations pathway where you can map your own strengths and start your own development journey.";
  }

  return "Continue your journey with Gyre. Click the button below to go back to the Home page.";
});

const continueButtonLink = computed(() => {
  if (data.value?.reviewerHasCompletedFoundationsPathway) return "/home";
  return "/foundations/default";
});

return (_ctx: any,_cache: any) => {
  return (_unref(data))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, _toDisplayString(headerText.value), 1),
            (_unref(data).isSelfReview)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_4, " You can access your Solo report by clicking the button below: "))
              : (_unref(data).subjectIsDummy || _unref(data).visibleOnlyToReviewer)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_5, " The results of you work are ready for you to view. " + _toDisplayString(_unref(data).subjectFirstName) + " won't see those results unless you share them. ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, " Thank you so much for reviewing " + _toDisplayString(_unref(data).subjectFirstName) + ". We'll use the data you've given us to create a Viewpoints Report for " + _toDisplayString(_unref(data).subjectFirstName) + ". The report will pull together your view with others who have also given " + _toDisplayString(_unref(data).subjectFirstName) + " feedback. This will help bring focus to " + _toDisplayString(_unref(data).subjectFirstName) + "'s leadership development. ", 1),
                    _createElementVNode("p", null, "You can see a full report on your view of " + _toDisplayString(_unref(data).subjectName) + " below.", 1)
                  ])),
            _createElementVNode("a", {
              href: `/soloreport/view/${props.id}`,
              "data-test": "report-ready-perspective-link",
              role: "button",
              class: "btn btn-default btn-lg center-flex",
              style: {"margin-bottom":"25px"}
            }, _toDisplayString(reportButtonText.value), 9, _hoisted_8),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, _toDisplayString(continueYourJourneyText.value), 1),
              _createElementVNode("a", {
                href: continueButtonLink.value,
                role: "button",
                class: "btn btn-primary btn-lg center-flex",
                "data-test": "report-ready-foundations-link"
              }, _toDisplayString(continueButtonText.value), 9, _hoisted_9)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})